export default __webpack_public_path__ + "static/media/tab-content-image-01.4bad9a38.png";